import { cn } from '../../utils/cn';

/**
 * Empty state component for when there's no data to display.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.icon] - Icon to display (Lucide icon component)
 * @param {string} props.title - Main message
 * @param {string} [props.description] - Secondary description
 * @param {React.ReactNode} [props.action] - Action button or link
 * @param {string} [props.className] - Additional classes
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  ...props
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center py-12 px-4 text-center',
        className
      )}
      {...props}
    >
      {icon && (
        <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-neutral-100">
          <div className="w-6 h-6 text-neutral-500">
            {icon}
          </div>
        </div>
      )}
      <h3 className="text-lg font-medium text-neutral-900 mb-1">
        {title}
      </h3>
      {description && (
        <p className="text-sm text-neutral-500 max-w-sm mb-4">
          {description}
        </p>
      )}
      {action && (
        <div className="mt-2">
          {action}
        </div>
      )}
    </div>
  );
}

/**
 * Compact empty state for inline use (e.g., in tables).
 */
export function EmptyStateInline({
  message = 'No data available',
  className,
}) {
  return (
    <div
      className={cn(
        'py-8 text-center text-sm text-neutral-500',
        className
      )}
    >
      {message}
    </div>
  );
}
